import React from 'react';
import Navbar from '../components/site/Navbar';
import Hero from '../components/site/Hero';
import LogoMarquee from '../components/site/LogoMarquee';
import IntroSection from '../components/site/IntroSection';
import Services from '../components/site/Services';
import OurWork from '../components/site/OurWork';
import FAQ from '../components/site/FAQ';
import Blog from '../components/site/Blog';
import FooterCTA from '../components/site/FooterCTA';
import Footer from '../components/site/Footer';

const Agency = () => {
  return (
    <main className="bg-white text-[#12367F]">
      <Navbar />
      <Hero />
      <LogoMarquee />
      <IntroSection />
      <Services />
      <OurWork />
      <FAQ />
      <Blog />
      <FooterCTA />
      <Footer />
    </main>
  );
};

export default Agency;
